import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	for: {
		id: 'search-page.common.status-target-date-display.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and target date e.g. "On track for August"',
	},
});
